import { combineReducers } from 'redux';
import { radioReducer } from './redux/radio/reducer';

const rootReducer = combineReducers({
    radioReducer
});

export default rootReducer;